import { RoutePath } from "#src/utils/route";
import { DevicesListRoutePath } from "#src/routes/organization/devices";

export const DevicesCreateRoutePath = DevicesListRoutePath.concat(
  new RoutePath<"mode">({
    title: "Create Device",
    path: "/create/:mode",
  })
);
